import { createContext } from "react"
import { PageLifecycle } from "src/types"

export const PageLifecycleContext = createContext<PageLifecycle>(PageLifecycle.Active)
